import chenYuxiaAuthorPhoto from "@/assets/template-showcase/chen-yuxia-author.jpg";
import chenYuxiaQingtongWorkshop from "@/assets/template-showcase/chen-yuxia-qingtong-workshop.jpg";

const OSS_BASE_URL = "https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/";

const chenYuxiaAuthor = {
  id: "4265",
  name: "陈玉霞",
  title: "传统插花艺术教师",
  profile: "长期从事中国传统插花教学与创作，关注花材生命姿态、器物关系与东方空间意境的数字化表达。",
};

const huangYunlingAuthor = {
  id: "4352",
  name: "黄云玲",
  title: "教授 · 插花技师",
  profile: "硕士、教授、福建农林大学专业学位校外研究生导师、插花技师，长期从事林科和园林类专业教学与研究，主讲《园林植物栽培养护》《森林营造技术》《插花与花艺设计》等课程，曾获福建省省级“优秀教师”等荣誉。",
};

const makeProvenance = (owner, values) => ({
  owner,
  sourceType: "作者原创数字作品",
  rights: "教学展示 · 授权二创",
  maintainer: "作者本人后台维护",
  ...values,
});

const templateShowcaseWorks = [
  {
    id: "2099099289996230656",
    seriesNo: "01",
    sourceName: "2026.8.28 下垂型筒花成品图",
    title: "下垂型筒花",
    subtitle: "中式筒花 · 下垂型构成",
    cover: `${OSS_BASE_URL}draft/178792305271447654e8806a04366ba4580243d9c5ce21787923052259.png`,
    author: huangYunlingAuthor,
    createdAt: "2026年8月28日",
    archiveNo: "LSHL-HYL-2026-001",
    container: "筒3",
    flowerCount: 18,
    technique: "中式插花",
    description: "以贴梗海棠建立舒展而下垂的主势，黄天霸百合形成明亮焦点，红果点出节奏；一叶兰与黄杨叶连接花体和筒器，使整体既有向下流动的韵律，又保持稳定重心。",
    structure: "海棠枝确定下垂轮廓，百合花位于视觉中心，红果形成小面积对比，一叶兰向下延伸并收束筒器周围的空间。",
    steps: ["确定筒器与下垂方向", "以海棠枝建立主势线", "配置百合与红果焦点", "用一叶兰和黄杨叶整理层次"],
    materials: [
      ["贴梗海棠", 3], ["黄天霸百合", 2], ["双头百合花苞", 1],
      ["绿色黄杨叶", 4], ["红果", 2], ["一叶兰", 6],
    ],
    stats: { views: 1682, likes: 218, comments: 31, rewards: 1680 },
    remix: { editors: 28, versions: 4, derivatives: 47, latest: "教学开放版 V1.3" },
    provenance: makeProvenance("黄云玲", { cited: 47, version: "V1.3", recordedAt: "2026-09-13 19:34" }),
  },
  {
    id: "2060195665534779392",
    seriesNo: "02",
    sourceName: "瓶",
    title: "向阳而生",
    subtitle: "中式瓶花 · 向日葵主题",
    cover: `${OSS_BASE_URL}common/1778253357326182fe18bb2ef4f8bbba32897d2e8db8e1778253357066.png`,
    effectImage: `${OSS_BASE_URL}common/1778200360865c124f7a4419548f6bfa7d7f3206c541c1778200360739.png`,
    author: chenYuxiaAuthor,
    authorPhoto: chenYuxiaAuthorPhoto,
    createdAt: "2026年5月29日",
    archiveNo: "LSHL-CYX-2026-002",
    container: "棕色筒",
    flowerCount: 17,
    technique: "中式插花",
    description: "三朵向日葵沿上升动势展开，散尾葵拉出轻盈轮廓，冬青红果形成细小而明亮的节奏。棕色筒器沉稳质朴，承托作品积极、温暖的情绪。",
    structure: "散尾葵构成高位主势，向日葵形成三点视觉焦点，红果穿插提亮，一叶兰和龟背叶完成中下部衔接。",
    steps: ["选择质朴筒器", "建立上扬主势线", "布置三点向日葵焦点", "穿插果材与叶材并平衡重心"],
    materials: [
      ["向日葵", 3], ["冬青", 3], ["一叶兰", 5], ["柏树叶", 2],
      ["散尾葵", 3], ["龟背叶", 1],
    ],
    stats: { views: 2186, likes: 286, comments: 48, rewards: 3860 },
    remix: { editors: 36, versions: 5, derivatives: 62, latest: "开放二创版 V1.4" },
    provenance: makeProvenance("陈玉霞", { cited: 62, version: "V1.4", recordedAt: "2026-05-29 11:04" }),
  },
  {
    id: "1993600792510070784",
    seriesNo: "03",
    sourceName: "pin",
    title: "青铜瓶花",
    subtitle: "中式瓶花 · 直立型构成",
    cover: `${OSS_BASE_URL}common/176181196190994a2052ac2fb414099a5144e7a7712b31761811961810.png`,
    effectImage: `${OSS_BASE_URL}common/17618119889835406289390aa490192649fef6f8fd5271761811988948.png`,
    author: chenYuxiaAuthor,
    authorPhoto: chenYuxiaQingtongWorkshop,
    createdAt: "2025年11月26日",
    archiveNo: "LSHL-CYX-2025-001",
    container: "青铜",
    flowerCount: 11,
    technique: "中式插花",
    description: "菠萝蜜枝条由青铜花器中向上伸展，粉色菊花构成清晰焦点，蓝星蕨叶和假叶树在中下部形成轻盈舒展的层次，整体呈现挺拔、清雅的东方气韵。",
    structure: "枝条建立纵向主势，三朵粉色菊花形成高低错落的视觉中心，蕨叶向两侧舒展并平衡花体，青铜器稳定作品重心。",
    steps: ["确定青铜花器正面", "以枝条建立纵向主势", "配置粉色菊花焦点", "补入蕨叶与叶材并调整留白"],
    materials: [
      ["菠萝蜜枝条", 3], ["假叶树", 2], ["菊花", 3], ["蓝星蕨叶", 3],
    ],
    stats: { views: 1438, likes: 211, comments: 32, rewards: 2180 },
    remix: { editors: 26, versions: 3, derivatives: 41, latest: "开放二创版 V1.2" },
    provenance: makeProvenance("陈玉霞", { cited: 41, version: "V1.2", recordedAt: "2025-11-26 16:40" }),
  },
  {
    id: "1970374312636448768",
    seriesNo: "04",
    sourceName: "篮花",
    title: "灯笼篮花",
    subtitle: "中式篮花 · 倾斜型构成",
    cover: `${OSS_BASE_URL}common/17579484616140196064690184904bc03e50dda6c9b1d1757948460854.png`,
    author: chenYuxiaAuthor,
    createdAt: "2025年9月23日",
    archiveNo: "LSHL-CYX-2025-002",
    container: "灯笼篮",
    flowerCount: 15,
    technique: "中式插花",
    description: "粉色芍药由深色灯笼篮中错落展开，狗牙花与菠萝蜜枝条拉出轻盈的倾斜动势，花边黄杨叶、洋兰叶和宽叶材承托下盘，形成疏密有致的自然空间。",
    structure: "高位枝条确定倾斜方向，三朵芍药形成中部焦点，叶材从两侧展开并稳定花体，深色篮器强化作品的沉静质感。",
    steps: ["确定灯笼篮主视角", "以枝条建立倾斜主势", "配置芍药视觉焦点", "用叶材连接花体并整理空间"],
    materials: [
      ["狗牙花", 2], ["菠萝蜜", 1], ["芍药", 3], ["花边黄杨叶", 4],
      ["洋兰叶", 2], ["龟背叶", 1], ["八角叶", 1], ["曼珠沙华", 1],
    ],
    stats: { views: 1786, likes: 263, comments: 39, rewards: 2680 },
    remix: { editors: 32, versions: 4, derivatives: 53, latest: "开放二创版 V1.3" },
    provenance: makeProvenance("陈玉霞", { cited: 53, version: "V1.3", recordedAt: "2025-09-23 14:26" }),
  },
  {
    id: "1833698213358469120",
    seriesNo: "05",
    sourceName: "半球形作品测试",
    title: "半球形玫瑰",
    subtitle: "礼仪花艺 · 半球形构成",
    cover: `${OSS_BASE_URL}draft/17121536568435499ddf6c1f149e7a8313055baf982b81712153658539.png`,
    author: huangYunlingAuthor,
    createdAt: "2024年9月11日",
    archiveNo: "LSHL-HYL-2024-001",
    container: "碗盏",
    flowerCount: 72,
    technique: "半球形花艺",
    description: "粉色玫瑰以紧密而均衡的半球形展开，九星叶在花面间形成细腻的绿色衬托，天门冬柔化外轮廓；高脚花器将花体托起，呈现端庄、饱满的礼仪气质。",
    structure: "玫瑰由中心向外建立均匀弧面，叶材填补花朵间隙并修整轮廓，使花面在各个方向保持圆润、完整的半球形态。",
    steps: ["确定高脚花器与花体比例", "建立半球形中心高度", "由中心向外均匀配置玫瑰", "补入叶材并修整圆润轮廓"],
    materials: [
      ["九星叶", 17], ["玫瑰", 53], ["天门冬", 2],
    ],
    stats: { views: 2688, likes: 428, comments: 67, rewards: 5880 },
    remix: { editors: 43, versions: 4, derivatives: 71, latest: "开放引用版 V1.3" },
    provenance: makeProvenance("黄云玲", { cited: 71, version: "V1.3", recordedAt: "2024-09-11 10:44" }),
  },
];

const workMap = templateShowcaseWorks.reduce((result, work) => {
  result[work.id] = {
    ...work,
    materials: work.materials.map(([name, count]) => ({ name, count })),
  };
  return result;
}, {});

function getTemplateShowcaseWork(id) {
  return workMap[String(id || "")] || null;
}

function isTemplateShowcaseWork(id) {
  return !!getTemplateShowcaseWork(id);
}

export {
  templateShowcaseWorks,
  getTemplateShowcaseWork,
  isTemplateShowcaseWork,
};
